import { writable } from 'svelte/store';
export const UI = writable({ showBooks: true, showDescriptors: true, showBestiary: true, });
export function showBestiary() {
    UI.update((ui) => {
        ui.showBestiary = true;
        return ui;
    });
}
export function showEncounters() {
    UI.update((ui) => {
        ui.showBestiary = false;
        return ui;
    });
}
export function toggleShowDescriptors() {
    UI.update((ui) => {
        ui.showDescriptors = !ui.showDescriptors;
        return ui;
    });
}
export function toggleShowBooks() {
    UI.update((ui) => {
        ui.showBooks = !ui.showBooks;
        return ui;
    });
}
